import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useFirebaseAuthLogin } from '@/features/auth/useFirebaseAuthLogin';

// Entry point for cross-domain SSO handoff from sabuesos.co: it lands here with
// a Firebase ID token in the URL fragment (#token=...&returnTo=...), obtained
// from an already-authenticated session on the other domain, and trades it for
// our own session without ever showing a login screen. The token travels in
// the fragment (not the querystring) so it's never sent to the server or
// captured in access logs/analytics.
export default function AuthHandoffPage() {
  const navigate = useNavigate();
  const { completeLogin } = useFirebaseAuthLogin();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const run = async () => {
      const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''));
      const idToken = hashParams.get('token');
      const returnTo = hashParams.get('returnTo') || '/adopt';

      // Clear the token from the URL/history immediately, regardless of outcome.
      window.history.replaceState(null, '', window.location.pathname);

      if (!idToken) {
        navigate('/login', { replace: true });
        return;
      }

      try {
        await completeLogin(idToken);
        navigate(returnTo, { replace: true });
      } catch {
        navigate('/login', { replace: true });
      }
    };

    run();
  }, [navigate, completeLogin]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex items-center gap-3 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span>Iniciando sesión...</span>
      </div>
    </div>
  );
}
